















































































import { Component, Mixins, Watch } from "vue-property-decorator";
import Search from "@/components/elements/utility/Search.vue";
import Pagination from "@/components/elements/utility/Pagination.vue";
import SalesOrderTable from "@/components/orders/SalesOrderTable.vue";
import StickyHScroll from "@/components/elements/utility/StickyHScroll.vue";
import ConfirmClearAll from "@/components/elements/modal/ConfirmClearAll.vue";
import { Mobile } from "@/mixins/mobile";
import { OrderMixin } from "@/mixins/orders/mixin";
import { SalesOrderPaging } from "@/mixins/orders/sales_order_paging";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { GlobalGetters } from "@/store/modules/global/types";

/**
 * FUPOF-200 — the rep's NetSuite Sales Orders, as a starting point for a
 * reorder. This is the entry point that serves the actual year-over-year case:
 * repeat orders that never had a Quote Builder quote behind them at all, and so
 * never appear on the quotes list.
 *
 * Rows are `SalesOrderSummary`, not `Order`. The quote-shaped mixin helpers
 * (sortedOrders, tabCounts, filteredOrders, effectiveStatus) all assume quote
 * semantics, so the list lives in SalesOrderPaging instead, which pages and
 * searches through the API — there are too many sales orders to hold whole.
 *
 * Everything else is reused from OrderMixin as-is: `reorderFromSalesOrder`,
 * `requestSalesOrderAction` (which brings the clear-cart confirmation with it),
 * `downloadNetSuiteSalesOrder` and `submitSearch`.
 */
@Component({
  components: {
    Search,
    Pagination,
    SalesOrderTable,
    StickyHScroll,
    ConfirmClearAll
  }
})
export default class SalesOrderList extends Mixins(
  Mobile,
  OrderMixin,
  SalesOrderPaging
) {
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetRole))
  userRole!: string;

  protected loader: any = null;

  @Watch("search")
  protected onSearchChanged(): void {
    this.queueSalesOrderSearch(this.search);
  }

  async created(): Promise<void> {
    const label = this.userRole === "admin" ? "All" : "My";
    this.loader = this.$loading.show(
      { opacity: 1 },
      { before: this.$createElement("h1", `Obtaining ${label} Sales Orders`) }
    );
    await this.loadSalesOrders(1, "");
    setTimeout(() => this.loader.hide(), 300);
  }
}
